import React from 'react';
import DatePicker from 'react-datepicker';
import { Input, Text } from '@mantine/core';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDateTimePicker = ({ 
  label, 
  placeholder, 
  value, 
  onChange, 
  error, 
  required = false,
  ...props 
}) => {
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <Input
      ref={ref}
      value={value}
      onClick={onClick}
      placeholder={placeholder}
      readOnly
      error={error}
      style={{ cursor: 'pointer' }}
    />
  ));

  // Generate year range: current year - 1 to current year + 10
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: 12 }, 
    (_, i) => currentYear - 1 + i
  );

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return (
    <div style={{ width: '100%' }}>
      {label && (
        <Text size="sm" fw={500} mb={5}>
          {label} {required && <Text component="span" c="red">*</Text>}
        </Text>
      )}
      <DatePicker
        selected={value}
        onChange={onChange}
        showTimeSelect
        timeFormat="hh:mm aa"
        timeIntervals={15}
        timeCaption="Time"
        dateFormat="dd MMM yyyy hh:mm aa"
        customInput={<CustomInput />}
        popperClassName="custom-datepicker-popper"
        popperPlacement="bottom-start"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        yearDropdownItemNumber={12}
        scrollableYearDropdown
        minDate={new Date(currentYear - 1, 0, 1)}
        maxDate={new Date(currentYear + 10, 11, 31)}
        {...props}
      />
      {error && (
        <Text size="xs" c="red" mt={5}>
          {error}
        </Text>
      )}
    </div>
  );
};

export default CustomDateTimePicker;